import FormField from "../form-field";
import Select from "../components/select";
import Api from "../../../../lib/api";
import ButtonsInput from "../components/buttons-input";
import LocalizationsHelper from "../../../../lib/localizations-helper";

export default class ConsultationField extends FormField {
    constructor(props = {}) {
        super(props);

        this.optionsData = [{
            label: LocalizationsHelper.get('fitsAnyTime'),
            value: null
        }];

        this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT = 'timeSelectToggleVisibility';
    }

    _beforeInit() {
        this.loading = true;

        this.$buttonsContainer = this.$root.querySelector('.f-consultation-input-buttons');
        this.$consultationTime = this.$root.querySelector('.f-consultation-time');
        this.$consultationTimeSelect = this.$consultationTime.querySelector('.listbox');

        if (this.$buttonsContainer) {
            this.switch = new ButtonsInput({
                $root: this.$buttonsContainer,
                subscriptions: [{
                    event: 'valueChange',
                    callback: this._handleSwitchValueChange.bind(this)
                }]
            });
        }

        this.timeSelect = new Select({
            $root: this.$consultationTimeSelect,
            subscriptions: [{
                event: 'valueChange',
                callback: this._handleTimeSelectValueChange.bind(this)
            }]
        });

        Api.get(`${Api.restSiteUrl}/1.0/helper/consultation-time`, {
            lang: document.querySelector('html').lang,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }).then((optionList) => {
            this.finishLoading();

            if (optionList.length) {
                this.optionsData.push(...optionList);
                this._initTimeSelect();
            }

            this._toggleFieldVisibility(!!optionList.length);
        });
    }

    _initTimeSelect() {
        this.timeSelect.addOptions(this.optionsData);
        this.timeSelect.selectFirstOption();
    }

    _toggleFieldVisibility(shouldShow) {
        if (!this.switch) {
            if (shouldShow) {
                this.$root.classList.remove('-hidden');
                this.$consultationTime.classList.remove('-hidden');
                this.controller.dispatch(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, true);
            } else {
                this.$root.classList.add('-hidden');
                this.controller.dispatch(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, false);
            }
        } else {
            this._toggleTimeSelectVisibility();
        }
    }

    _toggleTimeSelectVisibility(shouldShow) {
        if (shouldShow && this.switch.value === 'true') {
            this.$consultationTime.classList.remove('-hidden');
            this.controller.dispatch(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, true);
        } else {
            this.$consultationTime.classList.add('-hidden');
            this.controller.dispatch(this.TIME_SELECT_TOGGLE_VISIBILITY_EVENT, false);
        }

        if (this.switch.value) {
            this._setStatus('valid');
        }
    }

    _handleSwitchValueChange() {
        this._handleTimeSelectValueChange();
        this._toggleTimeSelectVisibility(true);
    }

    _handleTimeSelectValueChange() {
        const value = this.timeSelect.getValue();

        if (!this.controller.value && this.switch && !this.switch.value || value === 'null') {
            return;
        }

        this.controller.setValue(value);
    }

    _refresh() {
        if (this.switch) {
            this.switch.setInitialState();
        }
        
        this.timeSelect.setInitialState();
        this.controller.setValue(null);
    }

}